var map = {
	"./Loading-Icon.gif": 1206,
	"./app-awareness-phone.png": 407,
	"./app-modal-android@2x.png": 692,
	"./app-modal-iphone@2x.png": 693,
	"./app-promo-banner-background.png": 1207,
	"./box-prices/best-value.png": 694,
	"./box-prices/box-prices-hero.jpg": 784,
	"./box-prices/couples-box.jpg": 1208,
	"./box-prices/family-box.jpg": 1209,
	"./box-prices/four-person-box.jpg": 525,
	"./box-prices/most-popular.png": 695,
	"./box-prices/two-person-box.jpg": 524,
	"./discount-modal-header.jpg": 527,
	"./earn-reward-background.jpg": 1210,
	"./five-recipes/five-recipes.png": 696,
	"./gousto-boxes.jpg": 697,
	"./gousto-welcome-journey-rollover.jpg": 1211,
	"./hungry-for-savings.png": 1212,
	"./menu/FebYouary_desktop.jpg": 1213,
	"./menu/FebYouary_mobile.jpg": 1214,
	"./menu/FebYouary_tablet.jpg": 1215,
	"./menu/default_desktop_no_click.png": 1216,
	"./menu/default_mobile_no_click.png": 1217,
	"./menu/default_tablet_no_click.png": 1218,
	"./menu/spottyTileBorder.png": 698,
	"./my-gousto-pricing-modal.svg": 1219,
	"./pause-osr-modal-bg.jpg": 1220,
	"./product-placeholder.png": 528,
	"./recipe-placeholder.png": 342,
	"./red-rice-pattern.png": 529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 676;